// 🔧 use_voting_settings.js
// ✅ Purpose: Load voting settings (e.g., voting window, best in show toggle)
// ✅ Features:
// - Auto-loads settings from Firestore
// - Supports eventId being null initially without crashing
// - Always returns { settings, loading }

import { useState, useEffect } from "react";
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";

import { logger } from '../utils/logger';

export const useVotingSettings = (eventId) => {
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!eventId) {
      setSettings({});
      setLoading(false);
      return;
    }

    const fetchSettings = async () => {
      setLoading(true);
      try {
        const settingsRef = doc(db, "events", eventId, "settings", "voting");
        const settingsSnap = await getDoc(settingsRef);

        if (settingsSnap.exists()) {
          setSettings(settingsSnap.data());
        } else {
          logger.warn(`⚠️ Voting settings not found for eventId: ${eventId}`, {});
          setSettings({});
        }
      } catch (err) {
        logger.error("❌ Failed to fetch voting settings:", {
          value: err
        });
        setSettings({});
      }
      setLoading(false);
    };

    fetchSettings();
  }, [eventId]);

  return { settings, loading };
};
